import { checkAuth, Auth } from '@/api/signature'
import { wxSdkConfig } from '@/libs/wxjssdk'
import { Base64 } from 'js-base64'
import { Toast } from 'vant'

export default {
    state: {
        id: '',
        openid: '',
        userInfo: {},
        whetherSignature: false, // 是否签名成功了
        testing: '',
        
    },
    mutations: {
       
        setUserId (state, id) {
            state.id = id
        },
        setUserOpenId (state, openid) {
            state.openid = openid
        },
        setUserInfo (state, userInfo) {
            state.userInfo = userInfo
        },
        setWhetherSignature (state, whetherSignature) {
            state.whetherSignature = true
        },
        setTesting (state, testing) {
            state.testing = testing
        }
    },
    getters: {
        // messageUnreadCount: state => state.messageUnreadList.length
    },
    actions: {
        // 检验用户是否授权，授过权的话，存储用户信息，否则跳转授权
        checkUserAuth ({ state, commit, dispatch }) {
            Toast.loading({
                message: '拼命加载中...',
                forbidClick: true,
                loadingType: 'spinner',
                duration: 0
            })
            return new Promise((resolve, reject) => {
                try {
                    var targetPageUrl = window.location.href
                    wxSdkConfig() // 获取签名等配置
                    console.log('需要跳转的地址', targetPageUrl)
                    checkAuth().then(res => {
                        Toast.clear()
                        if (res.errCode === 0) {
                            const data = res.data
                            console.log('打印用户数据', data)
                            commit('setUserId', data.id)
                            commit('setUserOpenId', data.openid)
                            commit('setUserInfo', data)
                            // wxSdkConfig() // 获取签名等配置
                            dispatch('getAllCategoryPort')
                            resolve(data)
                        } else if (res.errCode === 401 || res.data == null) { // 重新授权
                            targetPageUrl = Base64.encode(targetPageUrl)
                            var href = `${Auth}?redirect_url=${targetPageUrl}`
                            console.log('加密的地址', targetPageUrl)
                            console.log('需要跳转的地址', href)
                            localStorage.setItem('redirectUrl', href)
                            window.location.href = href
                        }
                    }).catch(err => {
                        reject(err)
                    })
                } catch (error) {
                    reject(error)
                }
            })
        }
    }
}
